export const SECONDARY_VARIANT_STYLE = 'secondary';

export const FORM_GROUP_VARIANTS = {
    TIME: 'time',
    DATE: 'date',
    PLAIN: 'plain',
    BUTTON_RADIO_GROUP: 'buttonRadioGroup',
    RADIO_BUTTON_GROUP: 'radioButtonGroup',
    MULTI_SELECT: 'multiSelect',
    SELECT: 'select',
    TEXT: 'text',
    TEXT_AREA: 'textarea',
    POSTCODE_SEARCHABLE_LIST: 'postcodeSearchableList',
    CHECKBOX: 'checkbox',
    CURRENCY: 'currency',
    LIST: 'list',
    ATTACHMENT: 'attachment',
    NUMBER: 'number',
    AMOUNT: 'amount',
    RANGE: 'range',
    SEARCHABLE_LIST: 'searchableList',
    EDITOR: 'editor',
    ASYNC_SEARCHABLE_LIST:'asyncSearchableList',
    FILE: 'file',
    CHECKBOX_INLINE: 'checkbox-inline',
    SELECT_MANY: 'selectMany',
};

export const INPUT_TYPE = {
    UPLOAD: 'upload',
    MULTI_UPLOAD: 'multi upload',
    CALENDAR: 'calendar',
    DROP_DOWN: 'drop down',
    TEXT_AREA: 'text area',
    AMOUNT: 'amount',
    TEXT: 'text',
    TABLE: 'table',
    NO_INPUT: 'no input',
};